import React, { useState, useEffect } from 'react';
import { X, Sparkles, CalendarClock } from 'lucide-react';
import { useIsDemo } from '../../hooks/useIsDemo';

const STORAGE_KEY = 'pitboard_demo_banner_closed';

const DemoBanner = () => {
  const isDemo = useIsDemo();
  const [closed, setClosed] = useState(() => sessionStorage.getItem(STORAGE_KEY) === '1');
  const [suppressed, setSuppressed] = useState(() => !!window.__pbDemoBannerSuppressed);

  useEffect(() => {
    const handler = () => setSuppressed(!!window.__pbDemoBannerSuppressed);
    window.addEventListener('pb-demo-banner-visibility', handler);
    return () => window.removeEventListener('pb-demo-banner-visibility', handler);
  }, []);

  if (!isDemo || closed || suppressed) return null;

  const handleClose = () => {
    sessionStorage.setItem(STORAGE_KEY, '1');
    setClosed(true);
  };

  return (
    <div
      className="fixed bottom-0 inset-x-0 z-[10000] print:hidden"
      data-testid="demo-banner"
    >
      <div className="bg-gradient-to-r from-amber-500 via-orange-500 to-red-500 text-white shadow-[0_-4px_20px_rgba(0,0,0,0.25)]">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 py-3 sm:py-4 flex items-start sm:items-center gap-3 sm:gap-4">
          <span className="hidden sm:flex w-10 h-10 rounded-xl bg-white/20 items-center justify-center flex-shrink-0">
            <Sparkles size={20} className="text-white" />
          </span>

          <div className="flex-1 min-w-0 text-sm leading-snug">
            <p className="font-bold text-[13px] sm:text-sm mb-0.5">
              Vous êtes sur une version DÉMO de Pitboard Suite
            </p>
            <p className="text-white/90 text-[12px] sm:text-[13px]">
              Vous pouvez <strong>créer, modifier et interagir</strong> librement — mais toutes les données
              enregistrées sont <strong>publiques</strong>. Toutes les versions de Pitboard sont{' '}
              <strong>personnalisables sur demande</strong>, en option, pour correspondre à 100&nbsp;% à vos besoins.
              Prenez rendez-vous pour une <strong>démo personnalisée</strong> avec nos équipes et découvrez tout le
              potentiel de <strong>PITBOARD&nbsp;Suite</strong>.
            </p>
          </div>

          <button
            onClick={() => window.dispatchEvent(new CustomEvent('openDemoModal'))}
            data-testid="demo-banner-cta"
            className="hidden sm:inline-flex items-center gap-2 px-4 py-2 bg-white text-orange-700 rounded-lg font-semibold text-sm hover:bg-orange-50 transition-colors flex-shrink-0"
          >
            <CalendarClock size={16} />
            Prendre rendez-vous
          </button>

          <button
            onClick={handleClose}
            data-testid="demo-banner-close"
            aria-label="Fermer le bandeau démo"
            className="flex-shrink-0 w-8 h-8 rounded-lg bg-white/15 hover:bg-white/30 transition-colors flex items-center justify-center"
          >
            <X size={18} className="text-white" />
          </button>
        </div>
      </div>
    </div>
  );
};

export default DemoBanner;
